import { Transforms, type TunaEditor } from '@tunasong/plugin-lib'
import { isEntityRef } from '@tunasong/schemas'
import { Node as SlateNode, Path } from 'slate'
import { findElementPath } from '../hooks/use-element-path.js'

/**
 * Remove a generated block whose generation failed (GH #1958). An embedded image sits inside a
 * `ref` element, so the ref is what goes — removing only the image child would leave an empty
 * ref behind. The path is resolved when this runs, never captured earlier (GH #1953).
 *
 * Returns false when the element is no longer in the document.
 */
export const removeGeneratedBlock = (editor: TunaEditor, element: SlateNode): boolean => {
  const path = findElementPath(editor, element)
  if (!path) {
    return false
  }
  const root = editor as unknown as SlateNode
  const parentPath = path.length > 1 ? Path.parent(path) : undefined
  const parent = parentPath ? SlateNode.get(root, parentPath) : undefined
  Transforms.removeNodes(editor, { at: parent && isEntityRef(parent) ? parentPath : path })
  return true
}
